import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box } from '@mui/material';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getMediaPrefix, getSettingsByType } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { ImageSettingsInput } from '../../../components/Settings/SettingsInput/ImageSettingsInput';
import { Waiting } from '../../../components/Waiting/Waiting';

export const LogoSettings = () => {
  const [mediaPrefix, setMediaPrefix] = useState('');
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.FRONTEND)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();

    getMediaPrefix()
      .then((mp) => setMediaPrefix(mp))
      .catch((err) => toast.error(err.message));
  }, []);

  const getInitialValue = useCallback(
    (key: string): Settings =>
      settings.find((s) => s.key === key) ?? {
        type: SettingsType.FRONTEND,
        key,
        genericValue: { stringValue: '' },
        createdAt: new Date(),
        updatedAt: new Date(),
      },
    [settings],
  );

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1.5 }}
    >
      <Waiting open={loading} />
      <ImageSettingsInput
        name='Favicon'
        mediaPrefix={mediaPrefix}
        initialValue={getInitialValue('storefront_favicon')}
        onModify={refreshSettings}
      />
      <ImageSettingsInput
        name='Logo'
        mediaPrefix={mediaPrefix}
        initialValue={getInitialValue('storefront_header_logo')}
        onModify={refreshSettings}
      />
      <ImageSettingsInput
        name='Mail Logo'
        mediaPrefix={mediaPrefix}
        initialValue={getInitialValue('storefront_mail_logo')}
        onModify={refreshSettings}
      />
    </Box>
  );
};
